import _extends from "@babel/runtime/helpers/esm/extends";
var _path, _path2, _path3;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SvgFood = function SvgFood(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M21.549 27.745V7.255M18.128 7.382v5.632c0 .652.334 1.24.891 1.575l2.53 1.559",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      d: "M24.97 7.382v5.632c0 .652-.335 1.24-.892 1.575l-2.53 1.559M14.613 27.745V17.5",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round"
    })), _path3 || (_path3 = /*#__PURE__*/_jsx("path", {
      d: "M14.613 18.757h-3.66a.923.923 0 0 1-.922-.923v-5.918c.159-1.543 1.304-4.614 4.582-4.614v11.455Z",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }))]
  }));
};
export default SvgFood;